import { clsx } from 'clsx';
import type { ButtonHTMLAttributes } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost';
};

const variantClass: Record<NonNullable<Props['variant']>, string> = {
  primary:
    'bg-accent-500 text-ink-900 font-semibold shadow-btn hover:bg-accent-600 hover:text-white active:translate-y-px',
  secondary:
    'border border-ink-300 bg-cream text-ink-900 shadow-soft hover:border-ink-400 hover:bg-white',
  ghost:
    'text-ink-600 hover:text-ink-900 hover:bg-ink-100',
};

export function Button({ variant = 'primary', className, ...rest }: Props) {
  return (
    <button
      {...rest}
      className={clsx(
        'inline-flex items-center justify-center gap-1.5 rounded-xl px-4 py-2 text-sm font-medium',
        'transition-[color,background-color,border-color,box-shadow,transform] duration-150 ease-out',
        'focus-visible:ring-2 focus-visible:ring-accent-600 focus-visible:ring-offset-1',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        variantClass[variant],
        className,
      )}
    />
  );
}
